module.exports = __webpack_public_path__ + "img/director-work-icon3.792c767c.png";